import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { StringHelper } from '../helpers/strings.helper';
import { Subject } from 'rxjs';
import { OwnerBusinessesModel } from '../../shared/models/business.model';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class TerminalService {
	onDeclinePosRequest: any = new Subject();
	onDeclinePosRequest$ = this.onDeclinePosRequest.asObservable();
	onDeclineApprovedPosRequest: any = new Subject();
	onDeclineApprovedPosRequest$ = this.onDeclineApprovedPosRequest.asObservable();

	onDeclinePosRequestByBu: any = new Subject();
	onDeclinePosRequestByBu$ = this.onDeclinePosRequestByBu.asObservable();
	onApprovedPosRequestByBu: any = new Subject();
	onApprovedPosRequestByBu$ = this.onApprovedPosRequestByBu.asObservable();

	isPosRequestMobile: boolean;
	observePosRequestFormResize = new Subject();
	observePosRequestFormResize$ = this.observePosRequestFormResize.asObservable();

	observePosRequestForm = new Subject();
	observePosRequestForm$ = this.observePosRequestForm.asObservable();

	observePosAcceptanceForm = new Subject();
	observePosAcceptanceForm$ = this.observePosAcceptanceForm.asObservable();

	observeMobilePosAcceptance = new Subject();
	observeMobilePosAcceptance$ = this.observeMobilePosAcceptance.asObservable();

	persistStateOfTab = 0;

	canShowMobileRequestBtn: boolean;
	terminalForActivation: any;

	private posFormDetails = {
		index: 0,
		addressDetails: null,
		brmId: null,
		terminalModelId: null,
		useBusinessAddress: false,
		useLinkedBrm: false,
		brm: null,
	};

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
		private router: Router,
		private localStorage: LocalStorageService
	) { }

	observeRequestResize(isMobile) {
		this.isPosRequestMobile = isMobile;
		this.observePosRequestFormResize.next(isMobile);
	}

	observeAcceptanceForm() {
		this.observePosAcceptanceForm.next(true);
	}

	setSelectedPOSModel(model) {
		this.localStorage.save('SELECTED_POS_MODEL', JSON.stringify(model));
	}

	setPosFormDetails(data: any) {
		this.posFormDetails = data;
	}

	allowPosRequest() {
		return this.config.ALLOW_POS_REQUEST;
	}

	setObserveMobilePosAcceptance(param) {
		this.canShowMobileRequestBtn = param === 1;
		this.observeMobilePosAcceptance.next(param);
	}

	clearPosRequest() {
		const posFormDetails = {
			index: 0,
			addressDetails: null,
			brmId: null,
			terminalModelId: null,
			useBusinessAddress: false,
			useLinkedBrm: false,
			brm: null,
		};
		this.setPosFormDetails(posFormDetails);
	}

	getPosFormDetails() {
		return this.posFormDetails;
	}

	getSelectedPOSModel() {
		const posModel = this.localStorage.get('SELECTED_POS_MODEL');
		if (!posModel) {
			return null;
		}
		return JSON.parse(posModel);
	}

	cancelPOSRequestForm() {
		this.router.navigateByUrl('/main-app/business-user/pos-terminals');
		this.clearPosRequest();
	}

	observeRequestForm(data) {
		this.observePosRequestForm.next(data);
	}

	setOnDeclinePosReuest(val) {
		this.onDeclinePosRequest.next(val);
	}

	setOnDeclineApprovedPosReuest(val) {
		this.onDeclineApprovedPosRequest.next(val);
	}

	setOnDeclinePosRequestByBu(val) {
		this.onDeclinePosRequestByBu.next(val);
	}

	setOnApprovedPosRequestByBu(val) {
		this.onApprovedPosRequestByBu.next(val);
	}

	persistLastStateOfTab(val) {
		this.persistStateOfTab = val;
	}

	getPosTerminals(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agents/terminals?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAllTerminalFeatures(): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v2/business-moniepoint-features/all-features`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBusinessTerminalFeatures(id?: number): Promise<any> {
		let url;
		if (id) {
			url = `${this.config.MONIEPOINT_HOST}/api/v2/business-moniepoint-features/business-features/${id}`;
		} else {
			url = `${this.config.MONIEPOINT_HOST}/api/v2/business-moniepoint-features/business-features`;
		}
		return this.apiClientHelper.getForPromise(url);
	}

	applyBusinessTerminalFeatures(payload): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v2/business-moniepoint-features/apply-feature-to-business`;
		return this.apiClientHelper.putForPromise(url, payload);
	}

	getTerminalModels(): Promise<TerminalModelsResponse[]> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v2/pos-request-auth/terminal-models`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRequestedTerminals(params): Promise<RequestedTerminalsResponseModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/pos-requests/business?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getTerminalTransaction(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/report/api/v1/terminals/daily-insights?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}


	getTerminalTransactionWeekly(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/report/api/v1/terminals/weekly-insights?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getTerminalTransactionDailyInsights(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/report/api/v1/terminals/partner-daily-insights?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getTerminalTransactionWeeklyInsights(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/report/api/v1/terminals/partner-weekly-insights?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getNonTerminalTransactionInsights(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/report/api/v1/terminals/search?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	matchBrm(data): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v2/pos-request-auth/brm-match`;
		return this.apiClientHelper.postForPromise(url, data, false);
	}

	getBrmDetails(data): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pos-requests/business/brm-match`;
		return this.apiClientHelper.postForPromise(url, data, false);
	}

	getBrmDetailsV2(): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pos-requests/business/match-brm`;
		return this.apiClientHelper.getForPromise(url);
	}

	confirmUserBalance(data): Promise<TerminalPaymentConfirmationResponseModel> {
		const url = this.config.MONIEPOINT_HOST + `/api/v2/pos-request-auth/confirm-payment`;
		return this.apiClientHelper.postForPromise(url, data, false);
	}

	processTerminalRequestPayment(data): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v2/pos-request-auth/process-payment`;
		return this.apiClientHelper.postForPromise(url, data, false);
	}

	initiatePosRequest(data): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pos-requests/business`;
		return this.apiClientHelper.postForPromise(url, data, false);
	}

	acceptTerminal(id, data): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pos-requests/${id}/business/approve`;
		return this.apiClientHelper.postForPromise(url, data);
	}

	declineTerminal(id) {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/pos-requests/${id}/business/decline`;
		return this.apiClientHelper.postForPromise(url, {});
	}

	getTerminalImage(id) {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/pos-requests/${id}/model-image`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFeeWaiverRequestBRM(params): Promise<any> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/brm/requests?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFeeWaiverRequestDetails(requestId): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/sc/${requestId}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPricingPlanRequestDetails(requestId): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/sc/${requestId}`;
		return this.apiClientHelper.getForPromise(url);
	}

	approveFeeWaiverRequest(requestId): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/sc/approve/${requestId}`;
		return this.apiClientHelper.postForPromise(url, null);
	}

	rejectPricingPlanRequest(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/sc/reject`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	approvePricingPlanRequest(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/sc/approve`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	rejectFeeWaiverRequest(requestId, params): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/sc/reject/${requestId}`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	getTerminalRequestInfo(businessId): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/business-summary/${businessId}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBusinessesWithFeeWaiver(params): Promise<OwnerBusinessesModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terminal-fee-waiver/agents?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	downloadPricingPlanDocument(requestId): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/pricing-concession-request/documents/${requestId}/download`;
		return this.apiClientHelper.getAsBlobForPromise(url);
	}

	downloadPOSTransferAccountDetails(serialNo: string): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/protected-transfer/print-account-details-card?serialNo=${serialNo}`;
		return this.apiClientHelper.getAsBlobForPromise(url);
	}

	getFeeWaiverRequestImages(requestId): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/documents/${requestId}`;
		return this.apiClientHelper.getForPromise(url);
	}

	createFeeWaiverRequest(params): Promise<any> {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver`;
		return this.apiClientHelper.newPostAsFormDataForPromiseMultiFiles(url, params);
	}

	updateFeeWaiverRequest(params) {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver`;
		return this.apiClientHelper.newPutAsFormDataForPromiseMultiFiles(url, params);
	}

	deleteFeeWaiverDocument(documentId) {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/documents/single/${documentId}`;
		return this.apiClientHelper.delete(url);
	}

	downlaodFeeWaiverDocument(documentId) {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v1/terminal-fee-waiver/documents/single/${documentId}`;
		return this.apiClientHelper.getAsBlobForPromise(url);
	}

	makeFeeWaiverTerminalAssignmentRequest(params) {
		const url = this.config.MONIEPOINT_TERMINAL + `/api/v2/terminal-fee-waiver/assign/bulk-terminal`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	getFeeWavierRequestsForSC(params: object): Promise<any> {
		const urlString = StringHelper.toUrlString(params);

		const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terminal-fee-waiver/sc/requests?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPricingPlanRequestsForSC(params: object): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/pricing-concession-request/sc/?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFeeWavierRequestsDeailt(params: object): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_TERMINAL}/terminal-fee-waiver/'${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFeeWaiverEligibleBusiness() {
		const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terminal-fee-waiver/brm/agents/eligible`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSCTotalApprovalLeftPricingConcession() {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/pricing-concession-request/sc/number-of-approval-left`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSCTotalApprovalLeftFeeWavier() {
		const url = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terminal-fee-waiver/sc/approval-limit`;
		return this.apiClientHelper.getForPromise(url);
	}

	getUninsuredTerminalsCount(agentId?: number) {
		const baseUrl = `${this.config.MONIEPOINT_TERMINAL}/api/v1/terminals/uninsured-count`;
		const url = agentId ? `${baseUrl}?agentId=${agentId}` : baseUrl;
		return this.apiClientHelper.getForPromise(url);
	}
}

// Generated by https://quicktype.io

// Generated by https://quicktype.io

export interface RequestedTerminalsResponseModel {
	content: RequestedTerminal[];
	pageable: Pageable;
	last: boolean;
	totalElements: number;
	totalPages: number;
	sort: Sort;
	first: boolean;
	numberOfElements: number;
	size: number;
	number: number;
}

export interface RequestedTerminal {
	id?: number;
	agent?: Agent;
	code?: string;
	terminalModel?: TerminalModel;
	approvalStatus?: string;
	address?: string;
	localGovernment?: ContentLocalGovernment;
	landmark?: string;
	city?: string;
	aggregator?: Aggregator;
	createdOn?: string;
	terminationDate?: string;
}

export interface Agent {
	id: number;
	businessName: string;
	businessPhone: string;
	code: string;
	bankVerificationNumber: string;
	walletId: number;
	addressLineOne: string;
	addressLineTwo: string;
	localGovernment: LocalGovernment;
	city: string;
	createdOn: string;
	terminalCategorized: boolean;
}

export interface State {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	country: LocalGovernment;
	code: string;
	name: string;
	enableWebDeposit: boolean;
	enableWebCashout: boolean;
	enableWebAirtimePurchase: boolean;
	enableWebBillPayment: boolean;
	status: string;
}

export interface LocalGovernment {
	id: number;
	createdOn: string;
	lastModifiedOn: string;
	state?: State;
	name: string;
	code: string;
	sanefCode?: string;
	status: string;
	dialCode?: string;
}

export interface Aggregator {
	id: number;
	businessName: string;
	code: string;
	state: string;
	businessPhone: string;
}

export interface ContentLocalGovernment {
	id: number;
	state: State;
	name: string;
	code: string;
	status: string;
}

export interface TerminalModel {
	id: number;
	name: string;
	code: string;
	activationAmount: number;
	maximumAdditionalCharge: number;
	repairCost: number;
	operatingSystem: string;
	manufacturer: string;
	minimumAmount: number;
	defaultAdditionalFee: number;
	maximumAdditionalAmount: number;
	insuranceFee: number;
	refundAmount: null;
	maximumRefundPeriodInDays: number;
	minimumClusterManagerCommission: number;
	terminalImage: null;
	eligibleForPosRequest: boolean;
	videoLink: string;
	cautionFee: number;
	logisticsFee: number;
	description: null;
}

export interface Pageable {
	sort: Sort;
	pageSize: number;
	pageNumber: number;
	offset: number;
	unpaged: boolean;
	paged: boolean;
}

export interface Sort {
	sorted: boolean;
	unsorted: boolean;
}

export interface TerminalModelsResponse {
	id?: number;
	name?: string;
	code?: string;
	activationAmount?: number;
	maximumAdditionalCharge?: number;
	repairCost?: number;
	operatingSystem?: string;
	manufacturer?: string;
	minimumAmount?: number;
	defaultAdditionalFee?: number;
	maximumAdditionalAmount?: number;
	insuranceFee?: number;
	refundAmount?: any;
	description: string;
	maximumRefundPeriodInDays?: number;
	minimumClusterManagerCommission?: number;
	terminalImage?: string;
	eligibleForPosRequest?: boolean;
	videoLink?: any;
	cautionFee?: number;
	logisticsFee?: number;
}

// Generated by https://quicktype.io

export interface TerminalPaymentConfirmationResponseModel {
	hasSufficientFunds: boolean;
	brm: BRM;
}

export interface BRM {
	id: number;
	businessName: string;
	businessPhone: string;
	code: string;
	state: string;
	bvnImage: string;
}
